import { computed, Directive, input } from '@angular/core';
import { cn } from '@shared/helpers/cn';

@Directive({
  selector: '[appText]',
  standalone: true,
  host: { '[class]': 'styles()' },
})
export class AppTextDirective {
  #base = 'text-gray-600 !text-sm mb-3';
  appText = input<
    'subtitle1' | 'subtitle2' | 'title' | 'caption' | 'text' | ''
  >('');
  class = input<string>();

  public styles = computed(() => {
    return cn(
      this.#base,
      {
        '!text-lg !font-normal': this.appText() === 'subtitle1',
        '!text-base !font-normal ': this.appText() === 'subtitle2',
        'text-base opacity-80': this.appText() === 'text',
        'text-xs text-gray-500': this.appText() === 'caption',
      },
      this.class(),
    );
  });
}
